var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "d-flex flex-column align-items-center justify-content-center ulohy-row"
    },
    [
      _c(
        "div",
        { staticClass: "mb-30" },
        [
          _vm.kvizovaUloha
            ? _c("skoly-ulohy-row-item", {
                attrs: { uloha: _vm.kvizovaUloha, typ: "kvizova" }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.tvorivaUloha
            ? _c("skoly-ulohy-row-item", {
                attrs: {
                  uloha: _vm.tvorivaUloha,
                  typ: "tvoriva",
                  profil: _vm.profil
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "text-center" }, [
        _c("p", { staticClass: "text-21 text-bold text-dark mb-10" }, [
          _vm._v(_vm._s(_vm.label))
        ]),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "tag tag--mesiac",
            class: { "tag--active": _vm.isActive }
          },
          [_vm._v(_vm._s(_vm.mesiac))]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }